function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as e from "react";
import t from "react";
var r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function n(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

var o = {},
    c = {};
!function (e) {
  var n = r && r.__rest || function (e, t) {
    var r = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
        t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
      }
    }

    return r;
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.scripts = void 0;
  var o = t;
  e.scripts = {};

  var c = function c(t) {
    var r = document.querySelector('script[src="' + t + '"]');
    if (r) return e.scripts[t] = {
      loading: !1,
      error: null,
      scriptEl: r
    };
  };

  e.default = function (t) {
    var r = t.src,
        s = t.checkForExisting,
        a = void 0 !== s && s,
        l = n(t, ["src", "checkForExisting"]),
        u = r ? e.scripts[r] : void 0;
    !u && a && r && i && (u = c(r));
    var d = (0, o.useState)(u ? u.loading : Boolean(r)),
        f = d[0],
        p = d[1],
        v = (0, o.useState)(u ? u.error : null),
        b = v[0],
        y = v[1],
        g = (0, o.useState)(!1),
        m = g[0],
        O = g[1];
    return (0, o.useEffect)(function () {
      if (i && r && !m && !b) {
        var t;
        !(u = e.scripts[r]) && a && (u = c(r)), u ? t = u.scriptEl : ((t = document.createElement("script")).src = r, Object.keys(l).forEach(function (e) {
          void 0 === t[e] ? t.setAttribute(e, l[e]) : t[e] = l[e];
        }), u = e.scripts[r] = {
          loading: !0,
          error: null,
          scriptEl: t
        });

        var n = function n() {
          u && (u.loading = !1), p(!1), O(!0);
        },
            o = function o(e) {
          u && (u.error = e), y(e);
        };

        return t.addEventListener("load", n), t.addEventListener("error", o), document.body.appendChild(t), function () {
          t.removeEventListener("load", n), t.removeEventListener("error", o);
        };
      }
    }, [r]), [f, b];
  };

  var i = "undefined" != typeof window && void 0 !== window.document;
}(c), function (e) {
  var t = r && r.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.scripts = e.default = void 0;
  var n = c;
  Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function get() {
      return t(n).default;
    }
  }), Object.defineProperty(e, "scripts", {
    enumerable: !0,
    get: function get() {
      return n.scripts;
    }
  });
}(o);
var i = n(o);

function s() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref.connectUrl;

  var _e$useState = e.useState("closed"),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      r = _e$useState2[0],
      n = _e$useState2[1],
      _e$useState3 = e.useState(),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      o = _e$useState4[0],
      c = _e$useState4[1],
      _i2 = i({
    src: t || "https://app.stackone.com/stackone/connect.js",
    checkForExisting: !0
  }),
      _i3 = _slicedToArray(_i2, 2),
      s = _i3[0],
      a = _i3[1];

  e.useEffect(function () {
    "open" !== r && "closed" !== r && (a ? "opening" === r && n("closed") : s || "opening" === r && o && (n("open"), Connect.start(_objectSpread(_objectSpread({}, o), {}, {
      onClose: function onClose() {
        var _o$onCancel;

        n("closed"), (_o$onCancel = o.onCancel) === null || _o$onCancel === void 0 ? void 0 : _o$onCancel.call(o);
      }
    }))));
  }, [a, s, r, o]);
  var l = e.useCallback(function (e) {
    if (a) throw "Could not initiate StackOne Hub.";
    "open" !== r && (c(e), n("opening"));
  }, [s, a]);
  return {
    startConnect: l
  };
}

export { s as useStackOneHub };